export default __webpack_public_path__ + "static/difficulty-2f0cf218cc0bd38b57aab5fe1072ba32.png";